export const PERMISSIONS = {
  MANAGE_ADMIN: 'manage:admin',
  VIEW_ADMIN: 'view:admin',
  VIEW_PORTFOLIO: 'view:portfolio',
  VIEW_MESSAGING: 'view:messaging',
};

export const ALL_PERMISSIONS = Object.values(PERMISSIONS);
